import {Box, Flex, Icon, Text} from '@chakra-ui/react'
import {useSelector} from 'react-redux'
import {ReactComponent as NoteIcon} from '@assets/svgs/gym/note.svg'

interface GymData {
  is_finish: boolean
  // Thêm các trường khác nếu cần
}

const ProgressCard = () => {
  const {data} = useSelector((state: any) => state.gym)
  const totalCompletePart = data.filter((item: GymData) => item.is_finish)
  const remainingWords = data.length - totalCompletePart.length

  const StatisticItem = ({
    label,
    count,
    isCompleted = true,
  }: {
    label: string
    count: number
    isCompleted?: boolean
  }) => (
    <Flex flexDirection="column" alignItems="center">
      <Text fontSize="14px" fontWeight={500} color="#7C7C7C">
        {label}
      </Text>
      <Flex alignItems="center" gap="12px">
        <Icon
          as={NoteIcon}
          w="20px"
          h="20px"
          color={isCompleted ? 'inherit' : '#FF5558'}
          sx={!isCompleted ? {path: {fill: '#FF5558'}} : undefined}
        />
        <Text fontSize="28px" fontWeight={700}>
          {count}
        </Text>
      </Flex>
    </Flex>
  )

  return (
    <Box borderRadius="16px" bg="white" border="1px solid #EFEFEF">
      <Box px="56px" py="24px">
        <Text fontSize="20px" fontWeight={600} align="center">
          Tiến độ học của bạn
        </Text>
        <Flex mt="24px" justifyContent="space-between">
          <StatisticItem
            label="Số bài đã học"
            count={totalCompletePart.length}
          />
          <StatisticItem
            label="Số bài chưa học"
            count={remainingWords}
            isCompleted={false}
          />
        </Flex>
      </Box>
    </Box>
  )
}

export default ProgressCard
